import { Typography } from '@material-ui/core'
import { ComponentProps } from 'react'

export const typographyColor: ComponentProps<typeof Typography>['color'] =
  'textSecondary'
